define([
	"dojo/_base/array",
	"dojo/_base/declare",
	"dojo/_base/lang",
	"csi",
	"csi/heading/BooleanController",
	"csi/html",
	"csi/xml"
], function(array, declare, lang, csi, BooleanController, html, xml) {

	var COLOR = "AvailabilityColorExceptions",
		SIZE = "AvailabilitySizeExceptions",
		PAIR_COLOR = "AvailabilityPairColorExceptions",
		PAIR_SIZE = "AvailabilityPairSizeExceptions",
		DEFAULT = "AvailabilityDefault";

	return declare(BooleanController, {
		toWriter: function() {
			// summary: write operations to store change value
			var ctx = this.getContext();
			var view = ctx.view;
			var node = view.getViewNode();
			var urlColor = view.getContextColor(ctx);
			var urlSize = view.getContextSize(ctx);
			var bColor = (urlColor != csi.EMPTY_URL);
			var bSize = (urlSize != csi.EMPTY_URL);
			var cn = this.m_writer.changeNode(node.$URL);
			var bAdd;

			if (!bColor && !bSize) {
				// change default and remove all exceptions
				cn.changeAttribute(DEFAULT, xml.ATTR_BOOLEAN, this.newValue)
					.changeAttribute(PAIR_COLOR, xml.ATTR_REFVECTOR, [])
					.changeAttribute(PAIR_SIZE, xml.ATTR_REFVECTOR, [])
					.changeAttribute(COLOR, xml.ATTR_REFSET, [])
					.changeAttribute(SIZE, xml.ATTR_REFSET, []);

				this._fPostAction = lang.hitch(view, view.refreshDataRows, null);
			} else if (!bColor) {
				// toggle size exception
				bAdd = view.getSizeException(node, urlSize) < 0;
				cn.changeAttribute(SIZE, xml.ATTR_REFSET, [urlSize], bAdd, !bAdd);

				if (!view.bSizesOnly) {
					// update pair exceptions with this size and any color and refresh view
					this._updatePairs(node, urlSize, bAdd, PAIR_SIZE, PAIR_COLOR, COLOR);
					this._fPostAction = lang.hitch(view, view.refreshDataRows, null);
				}
			} else if (!bSize) {
				// toggle color exception
				bAdd = view.getColorException(node, urlColor) < 0;
				cn.changeAttribute(COLOR, xml.ATTR_REFSET, [urlColor], bAdd, !bAdd);

				if (!view.bColorsOnly) {
					// update pair exceptions with this color and any size and refresh row
					this._updatePairs(node, urlColor, bAdd, PAIR_COLOR, PAIR_SIZE, SIZE);
					this._fPostAction = lang.hitch(view, view.redrawNode, this.refNode);
				}
			} else {
				// toggle pair exception
				var n = view.getPairException(node, urlColor, urlSize);
				if (n >= 0) {
					// remove exception
					cn.removeAttributeKeys(PAIR_COLOR, xml.ATTR_REFVECTOR, [n])
						.removeAttributeKeys(PAIR_SIZE, xml.ATTR_REFVECTOR, [n]);
				} else {
					// add exception
					cn.changeAttribute(PAIR_COLOR, xml.ATTR_REFVECTOR, [urlColor], true)
						.changeAttribute(PAIR_SIZE, xml.ATTR_REFVECTOR, [urlSize], true);
				}
			}

			// if applying change to all, row, or column, do not cache changes on client - it is possible to lost data integrity
			// when held changes are published and re-cached 
			if (this._fPostAction) {
				this.m_writer.setCannotCache();
			}
		},

		_updatePairs: function(/*Node*/node,
							   /*String*/urlDim1,
							   /*Boolean*/bAddException,
							   /*String*/pairDim1,
							   /*String*/pairDim2,
							   /*String*/setDim2) {
			// summary: update pair exceptions when a row/col exception is changed
			var cn = this.m_writer.changeNode(node.$URL);
			var pair1 = node[pairDim1];
			var pair2 = node[pairDim2];
			var set2 = node[setDim2];
			var n = pair1.length;
			var addDim1 = [];
			var addDim2 = [];
			var removes = [];
			var pairs = {};
			var url;

			for (var i = 0; i < n; ++i) {
				if (pair1[i] == urlDim1) {
					url = pair2[i];

					if (bAddException) {
						// remove pair exception if adding dim1 exception
						removes.push(i);
					} else if (array.indexOf(set2, url) < 0) {
						// remove pair exception if removing dim1 exception and there is no corresponding dim2 exception
						removes.push(i);
					} else {
						// track remaining pair exceptions for dim2 when removing dim1 exception
						pairs[url] = true;
					}
				}
			}

			if (removes.length) {
				cn.removeAttributeKeys(pairDim1, xml.ATTR_REFVECTOR, removes)
					.removeAttributeKeys(pairDim2, xml.ATTR_REFVECTOR, removes);
			}

			// add pair exceptions for dim2 when removing dim1 exception
			if (!bAddException) {
				array.forEach(set2, function(urlDim2) {
					if (!pairs[urlDim2]) {
						addDim1.push(urlDim1);
						addDim2.push(urlDim2);
					}
				});
			}

			if (addDim1.length) {
				cn.changeAttribute(pairDim1, xml.ATTR_REFVECTOR, addDim1, true)
					.changeAttribute(pairDim2, xml.ATTR_REFVECTOR, addDim2, true);
			}
		}
	});
});